import script from "./LoadTrainConfigsMixin.vue?vue&type=script&lang=js"
export * from "./LoadTrainConfigsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__